import { Country } from '../types';

export const oceaniaData: Country[] = [
  {
    "code": "AS",
    "name": "American Samoa",
    "nameAr": "ساموا الأمريكية",
    "nameFr": "American Samoa",
    "cities": [
      {
        "name": "Eastern",
        "nameAr": "",
        "nameFr": "Eastern"
      },
      {
        "name": "Manuʻa",
        "nameAr": "",
        "nameFr": "Manuʻa"
      },
      {
        "name": "Rose",
        "nameAr": "",
        "nameFr": "Rose"
      },
      {
        "name": "Swains",
        "nameAr": "",
        "nameFr": "Swains"
      },
      {
        "name": "Western",
        "nameAr": "",
        "nameFr": "Western"
      }
    ]
  },
  {
    "code": "AU",
    "name": "Australia",
    "nameAr": "أستراليا",
    "nameFr": "Australia",
    "cities": [
      {
        "name": "New South Wales",
        "nameAr": "نيو ساوث ويلز",
        "nameFr": "Nouvelle Galles du Sud"
      },
      {
        "name": "Tasmania",
        "nameAr": "تسمانيا",
        "nameFr": "Tasmanie"
      },
      {
        "name": "Western Australia",
        "nameAr": "القسم الغربي من استراليا",
        "nameFr": "Australie occidentale"
      },
      {
        "name": "Queensland",
        "nameAr": "كوينزلاند",
        "nameFr": "Queensland"
      },
      {
        "name": "Victoria",
        "nameAr": "فيكتوريا",
        "nameFr": "Victoria"
      },
      {
        "name": "South Australia",
        "nameAr": "جنوب استراليا",
        "nameFr": "Australie du Sud"
      },
      {
        "name": "Northern Territory",
        "nameAr": "الإقليم الشمالي",
        "nameFr": "Territoire du Nord"
      },
      {
        "name": "Australian Capital Territory",
        "nameAr": "إقليم العاصمة الأسترالية",
        "nameFr": "Territoire de la capitale australienne"
      }
    ]
  },
  {
    "code": "CX",
    "name": "Christmas Island",
    "nameAr": "Christmas Island",
    "nameFr": "Christmas Island",
    "cities": []
  },
  {
    "code": "CC",
    "name": "Cocos (Keeling) Islands",
    "nameAr": "Cocos (Keeling) Islands",
    "nameFr": "Cocos (Keeling) Islands",
    "cities": []
  },
  {
    "code": "CK",
    "name": "Cook Islands",
    "nameAr": "جزر كوك",
    "nameFr": "Cook Islands",
    "cities": [
            {
                  "name": "Australian Capital Territory",
                  "nameAr": "Australian Capital Territory",
                  "nameFr": "Australian Capital Territory"
            },
            {
                  "name": "New South Wales",
                  "nameAr": "New South Wales",
                  "nameFr": "New South Wales"
            },
            {
                  "name": "Northern Territory",
                  "nameAr": "Northern Territory",
                  "nameFr": "Northern Territory"
            },
            {
                  "name": "Queensland",
                  "nameAr": "Queensland",
                  "nameFr": "Queensland"
            },
            {
                  "name": "South Australia",
                  "nameAr": "South Australia",
                  "nameFr": "South Australia"
            },
            {
                  "name": "Tasmania",
                  "nameAr": "Tasmania",
                  "nameFr": "Tasmania"
            },
            {
                  "name": "Victoria",
                  "nameAr": "Victoria",
                  "nameFr": "Victoria"
            },
            {
                  "name": "Western Australia",
                  "nameAr": "Western Australia",
                  "nameFr": "Western Australia"
            }
      ]
  },
  {
    "code": "FJ",
    "name": "Fiji Islands",
    "nameAr": "فيجي",
    "nameFr": "Fiji Islands",
    "cities": [
      {
        "name": "Northern",
        "nameAr": "شمالي",
        "nameFr": "Nord"
      },
      {
        "name": "Western",
        "nameAr": "الغربي",
        "nameFr": "Occidental"
      },
      {
        "name": "Central",
        "nameAr": "وسط",
        "nameFr": "Central"
      },
      {
        "name": "Eastern",
        "nameAr": "الشرقية",
        "nameFr": "Est"
      }
    ]
  },
  {
    "code": "PF",
    "name": "French Polynesia",
    "nameAr": "بولينيزيا الفرنسية",
    "nameFr": "French Polynesia",
    "cities": [
            {
                  "name": "Austral Islands",
                  "nameAr": "Îles austral",
                  "nameFr": "Austral Islands"
            },
            {
                  "name": "Leeward Islands",
                  "nameAr": "Îles sous le vent",
                  "nameFr": "Leeward Islands"
            },
            {
                  "name": "Marquesas Islands",
                  "nameAr": "Îles de Marquesas",
                  "nameFr": "Marquesas Islands"
            },
            {
                  "name": "Tuamotu-Gambier",
                  "nameAr": "Tuamotu-gambier",
                  "nameFr": "Tuamotu-Gambier"
            },
            {
                  "name": "Windward Islands",
                  "nameAr": "Îles du vent",
                  "nameFr": "Windward Islands"
            }
      ]
  },
  {
    "code": "GU",
    "name": "Guam",
    "nameAr": "غوام",
    "nameFr": "Guam",
    "cities": [
      {
        "name": "Agana Heights",
        "nameAr": "",
        "nameFr": "Agana Heights"
      },
      {
        "name": "Asan-Maina",
        "nameAr": "",
        "nameFr": "Asan-Maina"
      },
      {
        "name": "Barrigada",
        "nameAr": "",
        "nameFr": "Barrigada"
      },
      {
        "name": "Chalan Pago-Ordot",
        "nameAr": "",
        "nameFr": "Chalan Pago-Ordot"
      },
      {
        "name": "Dededo",
        "nameAr": "",
        "nameFr": "Dededo"
      },
      {
        "name": "Hågat",
        "nameAr": "",
        "nameFr": "Hågat"
      },
      {
        "name": "Hagåtña",
        "nameAr": "",
        "nameFr": "Hagåtña"
      },
      {
        "name": "Inarajan (Inalåhan)",
        "nameAr": "",
        "nameFr": "Inarajan (Inalåhan)"
      },
      {
        "name": "Mangilao",
        "nameAr": "",
        "nameFr": "Mangilao"
      },
      {
        "name": "Merizo (Malesso)",
        "nameAr": "",
        "nameFr": "Merizo (Malesso)"
      },
      {
        "name": "Mongmong-Toto-Maite",
        "nameAr": "",
        "nameFr": "Mongmong-Toto-Maite"
      },
      {
        "name": "Piti",
        "nameAr": "",
        "nameFr": "Piti"
      },
      {
        "name": "Santa Rita (Sånta Rita-Sumai)",
        "nameAr": "",
        "nameFr": "Santa Rita (Sånta Rita-Sumai)"
      },
      {
        "name": "Sinajana",
        "nameAr": "",
        "nameFr": "Sinajana"
      },
      {
        "name": "Talofofo (Talo'fo'fo)",
        "nameAr": "",
        "nameFr": "Talofofo (Talo'fo'fo)"
      },
      {
        "name": "Tamuning",
        "nameAr": "",
        "nameFr": "Tamuning"
      },
      {
        "name": "Umatac (Humåtak)",
        "nameAr": "",
        "nameFr": "Umatac (Humåtak)"
      },
      {
        "name": "Yigo",
        "nameAr": "",
        "nameFr": "Yigo"
      },
      {
        "name": "Yona",
        "nameAr": "",
        "nameFr": "Yona"
      }
    ]
  },
  {
    "code": "KI",
    "name": "Kiribati",
    "nameAr": "كيريباتي",
    "nameFr": "Kiribati",
    "cities": [
            {
                  "name": "Ba",
                  "nameAr": "Ba",
                  "nameFr": "Ba"
            },
            {
                  "name": "Bua",
                  "nameAr": "Bua",
                  "nameFr": "Bua"
            },
            {
                  "name": "Cakaudrove",
                  "nameAr": "Cakaudrove",
                  "nameFr": "Cakaudrove"
            },
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Eastern",
                  "nameAr": "Eastern",
                  "nameFr": "Eastern"
            },
            {
                  "name": "Kadavu",
                  "nameAr": "Kadavu",
                  "nameFr": "Kadavu"
            },
            {
                  "name": "Lau",
                  "nameAr": "Lau",
                  "nameFr": "Lau"
            },
            {
                  "name": "Lomaiviti",
                  "nameAr": "Lomaiviti",
                  "nameFr": "Lomaiviti"
            },
            {
                  "name": "Macuata",
                  "nameAr": "Mute",
                  "nameFr": "Macuata"
            },
            {
                  "name": "Nadroga-Navosa",
                  "nameAr": "Grahoga-navos",
                  "nameFr": "Nadroga-Navosa"
            },
            {
                  "name": "Naitasiri",
                  "nameAr": "I have it",
                  "nameFr": "Naitasiri"
            },
            {
                  "name": "Namosi",
                  "nameAr": "Nomis",
                  "nameFr": "Namosi"
            },
            {
                  "name": "Northern",
                  "nameAr": "Northern",
                  "nameFr": "Northern"
            },
            {
                  "name": "Ra",
                  "nameAr": "Ra",
                  "nameFr": "Ra"
            },
            {
                  "name": "Rewa",
                  "nameAr": "Rewa",
                  "nameFr": "Rewa"
            },
            {
                  "name": "Rotuma",
                  "nameAr": "Rotum",
                  "nameFr": "Rotuma"
            },
            {
                  "name": "Serua",
                  "nameAr": "Serua",
                  "nameFr": "Serua"
            },
            {
                  "name": "Tailevu",
                  "nameAr": "Tailev",
                  "nameFr": "Tailevu"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            }
      ]
  },
  {
    "code": "MH",
    "name": "Marshall Islands",
    "nameAr": "جزر مارشال",
    "nameFr": "Marshall Islands",
    "cities": [
            {
                  "name": "Ralik",
                  "nameAr": "Titled",
                  "nameFr": "Ralik"
            },
            {
                  "name": "Ratak",
                  "nameAr": "Ratak",
                  "nameFr": "Ratak"
            }
      ]
  },
  {
    "code": "FM",
    "name": "Micronesia",
    "nameAr": "ميكرونيزيا",
    "nameFr": "Micronesia",
    "cities": [
      {
        "name": "Yap",
        "nameAr": "ثرثرة",
        "nameFr": "Japper"
      },
      {
        "name": "Pohnpei",
        "nameAr": "بوهنباي",
        "nameFr": "Pohnpei"
      },
      {
        "name": "Chuuk",
        "nameAr": "شوك",
        "nameFr": "Chuuk"
      },
      {
        "name": "Kosrae",
        "nameAr": "كوسراي",
        "nameFr": "Kosrae"
      }
    ]
  },
  {
    "code": "NR",
    "name": "Nauru",
    "nameAr": "ناورو",
    "nameFr": "Nauru",
    "cities": [
            {
                  "name": "Aiwo",
                  "nameAr": "Theirs",
                  "nameFr": "Aiwo"
            },
            {
                  "name": "Anabar",
                  "nameAr": "An input",
                  "nameFr": "Anabar"
            },
            {
                  "name": "Anetan",
                  "nameAr": "Aneta",
                  "nameFr": "Anetan"
            },
            {
                  "name": "Anibare",
                  "nameAr": "Anibare",
                  "nameFr": "Anibare"
            },
            {
                  "name": "Baiti",
                  "nameAr": "Verse",
                  "nameFr": "Baiti"
            },
            {
                  "name": "Boe",
                  "nameAr": "Boe",
                  "nameFr": "Boe"
            },
            {
                  "name": "Buada",
                  "nameAr": "Puffy",
                  "nameFr": "Buada"
            },
            {
                  "name": "Denigomodu",
                  "nameAr": "Denigomond",
                  "nameFr": "Denigomodu"
            },
            {
                  "name": "Ewa",
                  "nameAr": "Ewa",
                  "nameFr": "Ewa"
            },
            {
                  "name": "Ijuw",
                  "nameAr": "Anemy",
                  "nameFr": "Ijuw"
            },
            {
                  "name": "Meneng",
                  "nameAr": "Silently",
                  "nameFr": "Meneng"
            },
            {
                  "name": "Nibok",
                  "nameAr": "Nibok",
                  "nameFr": "Nibok"
            },
            {
                  "name": "Uaboe",
                  "nameAr": "Uabee",
                  "nameFr": "Uaboe"
            },
            {
                  "name": "Yaren",
                  "nameAr": "Yaren",
                  "nameFr": "Yaren"
            }
      ]
  },
  {
    "code": "NC",
    "name": "New Caledonia",
    "nameAr": "كاليدونيا الجديدة",
    "nameFr": "New Caledonia",
    "cities": [
            {
                  "name": "Loyalty Islands Province",
                  "nameAr": "Loyalty Islands Province",
                  "nameFr": "Loyalty Islands Province"
            },
            {
                  "name": "North Province",
                  "nameAr": "Province du Nord",
                  "nameFr": "North Province"
            },
            {
                  "name": "South Province",
                  "nameAr": "Province du sud",
                  "nameFr": "South Province"
            }
      ]
  },
  {
    "code": "NZ",
    "name": "New Zealand",
    "nameAr": "نيوزيلندا",
    "nameFr": "New Zealand",
    "cities": [
            {
                  "name": "Auckland",
                  "nameAr": "Auckland",
                  "nameFr": "Auckland"
            },
            {
                  "name": "Bay of Plenty",
                  "nameAr": "Bay of Plenty",
                  "nameFr": "Bay of Plenty"
            },
            {
                  "name": "Canterbury",
                  "nameAr": "Canterbury",
                  "nameFr": "Canterbury"
            },
            {
                  "name": "Chatham Islands",
                  "nameAr": "Chatham Islands",
                  "nameFr": "Chatham Islands"
            },
            {
                  "name": "Gisborne",
                  "nameAr": "Gisborne",
                  "nameFr": "Gisborne"
            },
            {
                  "name": "Hawke's Bay",
                  "nameAr": "Hawke's Bay",
                  "nameFr": "Hawke's Bay"
            },
            {
                  "name": "Manawatu-Wanganui",
                  "nameAr": "Manawatu-Wanganui",
                  "nameFr": "Manawatu-Wanganui"
            },
            {
                  "name": "Marlborough",
                  "nameAr": "Marlborough",
                  "nameFr": "Marlborough"
            },
            {
                  "name": "Nelson",
                  "nameAr": "Nelson",
                  "nameFr": "Nelson"
            },
            {
                  "name": "Northland",
                  "nameAr": "Northland",
                  "nameFr": "Northland"
            },
            {
                  "name": "Otago",
                  "nameAr": "Otago",
                  "nameFr": "Otago"
            },
            {
                  "name": "Southland",
                  "nameAr": "Southland",
                  "nameFr": "Southland"
            },
            {
                  "name": "Taranaki",
                  "nameAr": "Taranaki",
                  "nameFr": "Taranaki"
            },
            {
                  "name": "Tasman",
                  "nameAr": "Tasman",
                  "nameFr": "Tasman"
            },
            {
                  "name": "Waikato",
                  "nameAr": "Waikato",
                  "nameFr": "Waikato"
            },
            {
                  "name": "Wellington",
                  "nameAr": "Wellington",
                  "nameFr": "Wellington"
            },
            {
                  "name": "West Coast",
                  "nameAr": "West Coast",
                  "nameFr": "West Coast"
            }
      ]
  },
  {
    "code": "NU",
    "name": "Niue",
    "nameAr": "نيوي",
    "nameFr": "Niue",
    "cities": [
            {
                  "name": "Alofi North",
                  "nameAr": "Mightyly",
                  "nameFr": "Alofi North"
            },
            {
                  "name": "Alofi South",
                  "nameAr": "Alofa south",
                  "nameFr": "Alofi South"
            },
            {
                  "name": "Avatele",
                  "nameAr": "Avatele",
                  "nameFr": "Avatele"
            },
            {
                  "name": "Hakupu",
                  "nameAr": "Afflass",
                  "nameFr": "Hakupu"
            },
            {
                  "name": "Hikutavake",
                  "nameAr": "Hikuvake",
                  "nameFr": "Hikutavake"
            },
            {
                  "name": "Lakepa",
                  "nameAr": "Lake coffee",
                  "nameFr": "Lakepa"
            },
            {
                  "name": "Liku",
                  "nameAr": "Liku",
                  "nameFr": "Liku"
            },
            {
                  "name": "Makefu",
                  "nameAr": "Makeffi",
                  "nameFr": "Makefu"
            },
            {
                  "name": "Mutalau",
                  "nameAr": "Mutalau",
                  "nameFr": "Mutalau"
            },
            {
                  "name": "Namukulu",
                  "nameAr": "The hospital",
                  "nameFr": "Namukulu"
            },
            {
                  "name": "Tamakautoga",
                  "nameAr": "Tamakautoga",
                  "nameFr": "Tamakautoga"
            },
            {
                  "name": "Toi",
                  "nameAr": "Toi",
                  "nameFr": "Toi"
            },
            {
                  "name": "Tuapa",
                  "nameAr": "Backplaces",
                  "nameFr": "Tuapa"
            },
            {
                  "name": "Vaiea",
                  "nameAr": "Woe",
                  "nameFr": "Vaiea"
            }
      ]
  },
  {
    "code": "NF",
    "name": "Norfolk Island",
    "nameAr": "جزيرة نورفولك",
    "nameFr": "Norfolk Island",
    "cities": []
  },
  {
    "code": "MP",
    "name": "Northern Mariana Islands",
    "nameAr": "جزر ماريانا الشمالية",
    "nameFr": "Northern Mariana Islands",
    "cities": []
  },
  {
    "code": "PW",
    "name": "Palau",
    "nameAr": "بالاو",
    "nameFr": "Palau",
    "cities": [
            {
                  "name": "Aimeliik",
                  "nameAr": "Ameliikik",
                  "nameFr": "Aimeliik"
            },
            {
                  "name": "Airai",
                  "nameAr": "Airai",
                  "nameFr": "Airai"
            },
            {
                  "name": "Angaur",
                  "nameAr": "Angaur",
                  "nameFr": "Angaur"
            },
            {
                  "name": "Hatohobei",
                  "nameAr": "Hatohobei",
                  "nameFr": "Hatohobei"
            },
            {
                  "name": "Kayangel",
                  "nameAr": "Kayael",
                  "nameFr": "Kayangel"
            },
            {
                  "name": "Koror",
                  "nameAr": "Increase",
                  "nameFr": "Koror"
            },
            {
                  "name": "Melekeok",
                  "nameAr": "Melekeok",
                  "nameFr": "Melekeok"
            },
            {
                  "name": "Ngaraard",
                  "nameAr": "To eat",
                  "nameFr": "Ngaraard"
            },
            {
                  "name": "Ngarchelong",
                  "nameAr": "Ngarchelong",
                  "nameFr": "Ngarchelong"
            },
            {
                  "name": "Ngardmau",
                  "nameAr": "Kerdown",
                  "nameFr": "Ngardmau"
            },
            {
                  "name": "Ngatpang",
                  "nameAr": "Ngatpang",
                  "nameFr": "Ngatpang"
            },
            {
                  "name": "Ngchesar",
                  "nameAr": "Nkchesar",
                  "nameFr": "Ngchesar"
            },
            {
                  "name": "Ngeremlengui",
                  "nameAr": "Ngeremlengui",
                  "nameFr": "Ngeremlengui"
            },
            {
                  "name": "Ngiwal",
                  "nameAr": "Ngiwal",
                  "nameFr": "Ngiwal"
            },
            {
                  "name": "Peleliu",
                  "nameAr": "Turn over",
                  "nameFr": "Peleliu"
            },
            {
                  "name": "Sonsorol",
                  "nameAr": "Sonsorol",
                  "nameFr": "Sonsorol"
            }
      ]
  },
  {
    "code": "PG",
    "name": "Papua New Guinea",
    "nameAr": "بابوا غينيا الجديدة",
    "nameFr": "Papua New Guinea",
    "cities": [
            {
                  "name": "Bougainville",
                  "nameAr": "Bougainville",
                  "nameFr": "Bougainville"
            },
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Chimbu",
                  "nameAr": "Bur",
                  "nameFr": "Chimbu"
            },
            {
                  "name": "East New Britain",
                  "nameAr": "East New Britain",
                  "nameFr": "East New Britain"
            },
            {
                  "name": "East Sepik",
                  "nameAr": "East",
                  "nameFr": "East Sepik"
            },
            {
                  "name": "Eastern Highlands",
                  "nameAr": "Eastern Highlands",
                  "nameFr": "Eastern Highlands"
            },
            {
                  "name": "Enga",
                  "nameAr": "Nake",
                  "nameFr": "Enga"
            },
            {
                  "name": "Gulf",
                  "nameAr": "Gulf",
                  "nameFr": "Gulf"
            },
            {
                  "name": "Hela",
                  "nameAr": "Hela",
                  "nameFr": "Hela"
            },
            {
                  "name": "Jiwaka",
                  "nameAr": "Burn it",
                  "nameFr": "Jiwaka"
            },
            {
                  "name": "Madang",
                  "nameAr": "Madang",
                  "nameFr": "Madang"
            },
            {
                  "name": "Manus",
                  "nameAr": "Manus",
                  "nameFr": "Manus"
            },
            {
                  "name": "Milne Bay",
                  "nameAr": "Milne Bay",
                  "nameFr": "Milne Bay"
            },
            {
                  "name": "Morobe",
                  "nameAr": "Morobe",
                  "nameFr": "Morobe"
            },
            {
                  "name": "New Ireland",
                  "nameAr": "New Ireland",
                  "nameFr": "New Ireland"
            },
            {
                  "name": "Oro",
                  "nameAr": "Oro",
                  "nameFr": "Oro"
            },
            {
                  "name": "Port Moresby",
                  "nameAr": "Port Moresby",
                  "nameFr": "Port Moresby"
            },
            {
                  "name": "Sandaun",
                  "nameAr": "Sandadaun",
                  "nameFr": "Sandaun"
            },
            {
                  "name": "Southern Highlands",
                  "nameAr": "Southern Highlands",
                  "nameFr": "Southern Highlands"
            },
            {
                  "name": "West New Britain",
                  "nameAr": "West New Britain",
                  "nameFr": "West New Britain"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            },
            {
                  "name": "Western Highlands",
                  "nameAr": "Western Highlands",
                  "nameFr": "Western Highlands"
            }
      ]
  },
  {
    "code": "PN",
    "name": "Pitcairn Island",
    "nameAr": "جزر بيتكيرن",
    "nameFr": "Pitcairn Island",
    "cities": []
  },
  {
    "code": "WS",
    "name": "Samoa",
    "nameAr": "ساموا",
    "nameFr": "Samoa",
    "cities": [
            {
                  "name": "A'ana",
                  "nameAr": "Apu",
                  "nameFr": "A'ana"
            },
            {
                  "name": "Aiga-i-le-Tai",
                  "nameAr": "Aiga-i-le-Tai",
                  "nameFr": "Aiga-i-le-Tai"
            },
            {
                  "name": "Atua",
                  "nameAr": "Atua",
                  "nameFr": "Atua"
            },
            {
                  "name": "Fa'asaleleaga",
                  "nameAr": "Fa'asaleleaga",
                  "nameFr": "Fa'asaleleaga"
            },
            {
                  "name": "Gaga'emauga",
                  "nameAr": "Gaga'emauga",
                  "nameFr": "Gaga'emauga"
            },
            {
                  "name": "Gaga'ifomauga",
                  "nameAr": "Gaga'ifomauga",
                  "nameFr": "Gaga'ifomauga"
            },
            {
                  "name": "Palauli",
                  "nameAr": "Palauli",
                  "nameFr": "Palauli"
            },
            {
                  "name": "Satupa'itea",
                  "nameAr": "Satupa'itea",
                  "nameFr": "Satupa'itea"
            },
            {
                  "name": "Tuamasaga",
                  "nameAr": "Tuamasaga",
                  "nameFr": "Tuamasaga"
            },
            {
                  "name": "Va'a-o-Fonoti",
                  "nameAr": "Vaʻi-O-phonoti",
                  "nameFr": "Va'a-o-Fonoti"
            },
            {
                  "name": "Vaisigano",
                  "nameAr": "Vaisigano",
                  "nameFr": "Vaisigano"
            }
      ]
  },
  {
    "code": "SB",
    "name": "Solomon Islands",
    "nameAr": "جزر سليمان",
    "nameFr": "Solomon Islands",
    "cities": [
            {
                  "name": "Central",
                  "nameAr": "Central",
                  "nameFr": "Central"
            },
            {
                  "name": "Choiseul",
                  "nameAr": "Choiseul",
                  "nameFr": "Choiseul"
            },
            {
                  "name": "Guadalcanal",
                  "nameAr": "Guadalcanal",
                  "nameFr": "Guadalcanal"
            },
            {
                  "name": "Honiara",
                  "nameAr": "Honeycomb",
                  "nameFr": "Honiara"
            },
            {
                  "name": "Isabel",
                  "nameAr": "Isabel",
                  "nameFr": "Isabel"
            },
            {
                  "name": "Makira-Ulawa",
                  "nameAr": "Missing up",
                  "nameFr": "Makira-Ulawa"
            },
            {
                  "name": "Malaita",
                  "nameAr": "Malaita",
                  "nameFr": "Malaita"
            },
            {
                  "name": "Rennell and Bellona",
                  "nameAr": "Rennell and Bellona",
                  "nameFr": "Rennell and Bellona"
            },
            {
                  "name": "Temotu",
                  "nameAr": "Temotu",
                  "nameFr": "Temotu"
            },
            {
                  "name": "Western",
                  "nameAr": "Western",
                  "nameFr": "Western"
            }
      ]
  },
  {
    "code": "TK",
    "name": "Tokelau",
    "nameAr": "توكيلاو",
    "nameFr": "Tokelau",
    "cities": []
  },
  {
    "code": "TO",
    "name": "Tonga",
    "nameAr": "تونغا",
    "nameFr": "Tonga",
    "cities": [
            {
                  "name": "Haʻapai",
                  "nameAr": "Haʻapai",
                  "nameFr": "Haʻapai"
            },
            {
                  "name": "ʻEua",
                  "nameAr": "ʻEua",
                  "nameFr": "ʻEua"
            },
            {
                  "name": "Niuas",
                  "nameAr": "Niuas",
                  "nameFr": "Niuas"
            },
            {
                  "name": "Tongatapu",
                  "nameAr": "Tongatapu",
                  "nameFr": "Tongatapu"
            },
            {
                  "name": "Vavaʻu",
                  "nameAr": "Vavaʻu",
                  "nameFr": "Vavaʻu"
            }
      ]
  },
  {
    "code": "TV",
    "name": "Tuvalu",
    "nameAr": "توفالو",
    "nameFr": "Tuvalu",
    "cities": [
            {
                  "name": "Funafuti",
                  "nameAr": "Funfuta",
                  "nameFr": "Funafuti"
            },
            {
                  "name": "Nanumanga",
                  "nameAr": "Nanumga",
                  "nameFr": "Nanumanga"
            },
            {
                  "name": "Nanumea",
                  "nameAr": "Stiff",
                  "nameFr": "Nanumea"
            },
            {
                  "name": "Niutao Island Council",
                  "nameAr": "Nutoo Island Council",
                  "nameFr": "Niutao Island Council"
            },
            {
                  "name": "Nui",
                  "nameAr": "Great",
                  "nameFr": "Nui"
            },
            {
                  "name": "Nukufetau",
                  "nameAr": "Nuquosa",
                  "nameFr": "Nukufetau"
            },
            {
                  "name": "Nukulaelae",
                  "nameAr": "Nukulaelae",
                  "nameFr": "Nukulaelae"
            },
            {
                  "name": "Vaitupu",
                  "nameAr": "Vaitupu",
                  "nameFr": "Vaitupu"
            }
      ]
  },
  {
    "code": "VU",
    "name": "Vanuatu",
    "nameAr": "فانواتو",
    "nameFr": "Vanuatu",
    "cities": [
            {
                  "name": "Malampa",
                  "nameAr": "Malampa",
                  "nameFr": "Malampa"
            },
            {
                  "name": "Penama",
                  "nameAr": "Penama",
                  "nameFr": "Penama"
            },
            {
                  "name": "Sanma",
                  "nameAr": "Sanma",
                  "nameFr": "Sanma"
            },
            {
                  "name": "Shefa",
                  "nameAr": "Shefa",
                  "nameFr": "Shefa"
            },
            {
                  "name": "Tafea",
                  "nameAr": "Tafea",
                  "nameFr": "Tafea"
            },
            {
                  "name": "Torba",
                  "nameAr": "Torba",
                  "nameFr": "Torba"
            }
      ]
  },
  {
    "code": "WF",
    "name": "Wallis and Futuna Islands",
    "nameAr": "واليس وفوتونا",
    "nameFr": "Wallis and Futuna Islands",
    "cities": []
  }
];
